import { useEffect, useRef, useState } from 'react'
import { Asset } from '@/organisms/AngelPlayer'
import { useGuildMember } from '@/services/GuildUserService'
import { isAngelBehindTheScenes } from '@/utils/SpecialProjectUtils'

interface AttributionPlayerValues {
  shouldShowAttribution: boolean
  fullscreenAttributionClasses: string
}

interface UseAttributionPlayerProps {
  asset?: Asset
  skip?: boolean
}

export const useAttributionPlayer = ({ asset, skip }: UseAttributionPlayerProps): AttributionPlayerValues => {
  const assetProjectSlug = asset?.projectSlug
  const [fullscreenAttributionClasses, setFullscreenAttributionClasses] = useState('')
  const shouldShowAttribution = !skip && !isAngelBehindTheScenes(assetProjectSlug as string) && !!asset
  const { loading: isLoadingGuildUser, isGuildMember } = useGuildMember()
  const timeoutRef = useRef<NodeJS.Timeout>(undefined)

  useEffect(() => {
    if (shouldShowAttribution && !isLoadingGuildUser && !isGuildMember) {
      setFullscreenAttributionClasses('')
      timeoutRef.current = setTimeout(() => {
        setFullscreenAttributionClasses('hidden')
      }, 6000)
    }

    return () => {
      clearTimeout(timeoutRef.current as NodeJS.Timeout)
    }
  }, [shouldShowAttribution, isGuildMember, isLoadingGuildUser])

  return {
    fullscreenAttributionClasses,
    shouldShowAttribution,
  }
}
